module.exports = __webpack_public_path__ + "img/ticket.53a7794e.svg";